import { DateType, TablesScreenInput } from 'generated/graphql';

export enum TableScreenQueryParam {
  Tab = 't',
  Group = 'g',
  Input = 'i',
  Search = 's',
}

/** The page of each table paged past its first, by the table's identifier. */
export type TablePages = Record<string, number>;

interface TableScreenInputMinified {
  s: string;
  d: {
    s: string;
    e: string;
    t: DateType;
  }[];
  p?: TablePages;
}

const minifyInput = (input: TablesScreenInput, pages: TablePages): TableScreenInputMinified => ({
  s: input.search,
  d: input.dates.map((d) => ({
    s: d.start,
    e: d.end,
    t: d.type,
  })),
  p: pages,
});

const parse = (json: string): TableScreenInputMinified | null => {
  try {
    return JSON.parse(atob(json)) || null;
  } catch {
    return null;
  }
};

export const tableScreenInputToString = (input: TablesScreenInput | null, pages: TablePages = {}): string => {
  try {
    if (!input) return '';

    return btoa(JSON.stringify(minifyInput(input, pages)));
  } catch {
    return '';
  }
};

export const tableScreenInputFromString = (json: string): TablesScreenInput | null => {
  const minified = parse(json);
  if (!minified) return null;

  return {
    search: minified.s ?? '',
    dates: (minified.d ?? []).map((d) => ({
      start: d.s,
      end: d.e,
      type: d.t,
    })),
  };
};

export const tablePagesFromString = (json: string): TablePages => {
  const pages = parse(json)?.p;
  if (!pages || typeof pages !== 'object') return {};

  return Object.fromEntries(Object.entries(pages).filter(([, page]) => typeof page === 'number' && page > 0));
};
